import template from './feature-filter-tagged.template.html'

/* @ngInject */
export default function featureFilterIconDirective() {
  return {
    template
  }
}
